import React from 'react';

function Usage() {
  return <div>Usage</div>;
}

export default Usage;
